import { PayloadAction } from '@reduxjs/toolkit';
import apiTypes from 'src/api/optimalprint-sdk.d';
import { FormatState } from 'src/store/format/types';

const setAllFormatsReducer = (state: FormatState, action: PayloadAction<apiTypes.AppBundle.Api.Entity.PaperFormat.V1.IPaperFormat[]|undefined>) => {
  state.allFormats = action.payload;
};

export default setAllFormatsReducer;
